import { Injectable, signal, computed } from '@angular/core';
import { PatrolAlert } from './patrol-monitor.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PaginatedResponse, PatrolAlertFilter, PatrolFilters } from '../models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';



@Injectable({
  providedIn: 'root'
})
export class PositionAlertService {
  // Signal para controlar abertura do modal
  private readonly baseUrl = environment.apiUrl || 'http://localhost:3000';
  private isOpenSignal = signal<boolean>(false);
  private currentAlertSignal = signal<PatrolAlert | null>(null);
  
  // Subject para comunicação com o componente
  private openModalSubject = new BehaviorSubject<PatrolAlert | null>(null);
  openModal$ = this.openModalSubject.asObservable();

  // Subject para quando o alerta é resolvido
  private alertResolvedSubject = new Subject<void>();
  alertResolved$ = this.alertResolvedSubject.asObservable();

  // Computed para verificar se o modal está aberto
  isOpen = this.isOpenSignal.asReadonly();
  currentAlert = this.currentAlertSignal.asReadonly();

  constructor(private http: HttpClient) {}

  /**
   * Abre o modal individual com o alerta específico
   */
  openModal(alert: PatrolAlert): void {
    
    this.currentAlertSignal.set(alert);
    this.isOpenSignal.set(true);
    this.openModalSubject.next(alert);
  }

  /**
   * Fecha o modal individual
   */
  closeModal(): void {
    this.isOpenSignal.set(false);
    this.currentAlertSignal.set(null);
    this.openModalSubject.next(null);
  }

  /**
   * Resolve o alerta atual
   */
  resolveCurrentAlert(): void {
    const alert = this.currentAlertSignal();
    if (alert) {
      this.alertResolvedSubject.next();
      this.openModalSubject.next({ ...alert, action: 'resolve' } as any);
    }
  }

  /**
   * Resolve um alerta específico pelo ID
   */
  resolveAlert(alertId: string): void {
    const alert = this.currentAlertSignal();
    if (alert && alert.id === alertId) {
      this.alertResolvedSubject.next();
    }
  }

  getAlerts(filters?: PatrolAlertFilter): Observable<PaginatedResponse<PatrolAlert>> {
    let params = new HttpParams();
    if (filters) {
      // company_id e position_id são obrigatórios
      if (filters.company_id) {
        params = params.set('companyId', filters.company_id.toString());
      }
      if (filters.position_id) {
        params = params.set('positionId', filters.position_id);
      }
      if (filters.status) params = params.set('status', filters.status);
      if (filters.search) params = params.set('search', filters.search);
      if (filters.page) params = params.set('page', filters.page.toString());
      if (filters.limit) params = params.set('limit', filters.limit.toString());
      if (filters.type) {
        params = params.set('type', filters.type);
      }
    }

    return this.http.get<PaginatedResponse<PatrolAlert>>(`${this.baseUrl}/patrol-monitor`, {
      params,
    });
  }
}